export default "__VITE_ASSET__CPMcJOxB__"